import { render, staticRenderFns } from "./RatingDistributionWidget.vue?vue&type=template&id=6f502ae6&"
import script from "./RatingDistributionWidget.vue?vue&type=script&lang=js&"
export * from "./RatingDistributionWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports